/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserIncidentFootageMarkerFromJSON, UserIncidentFootageMarkerToJSON, } from './UserIncidentFootageMarker';
/**
 * Check if a given object implements the UserIncidentFootageMarkerCollectionResponse interface.
 */
export function instanceOfUserIncidentFootageMarkerCollectionResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function UserIncidentFootageMarkerCollectionResponseFromJSON(json) {
    return UserIncidentFootageMarkerCollectionResponseFromJSONTyped(json, false);
}
export function UserIncidentFootageMarkerCollectionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(UserIncidentFootageMarkerFromJSON)),
    };
}
export function UserIncidentFootageMarkerCollectionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(UserIncidentFootageMarkerToJSON)),
    };
}
